import { put, takeEvery } from 'redux-saga/effects';

import { fetchLoginPage } from 'ApiPackage/MainModule/services/core';

import { coreSetLoginPage } from '../actions/coreActions';
import { CoreActionsEnum } from '../enums/CoreActionsEnum';
import { sagaWrapper } from '../common/sagaWrapper';

export function* watchCoreSaga() {
  yield takeEvery(CoreActionsEnum.CORE_GET_LOGIN_PAGE, coreGetLoginPageSaga);
}

function* coreGetLoginPageSaga() {
  function* funcTry() {
    const response: string = yield fetchLoginPage();
    yield put(coreSetLoginPage(response));
  }

  yield sagaWrapper({
    funcTry,
  });
}
